// components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionContext';

const ProtectedRoute = ({ element }) => {
    const { UserData, loading } = usePermissions();

    if (loading) return <div>Loading...</div>;
    if (!UserData) return <Navigate to="/clientlogin" replace />;

    return element;
};

export default ProtectedRoute;